export const SET_PROFILE = 'SET_PROFILE';
export const SELECT_ALL_PROFILES = 'SELECT_ALL_PROFILES';
export const ADD_PROFILE = 'ADD_PROFILE';
export const REMOVE_PROFILE = 'REMOVE_PROFILE';
export const REMOVE_ALL_PROFILE = 'REMOVE_ALL_PROFILE';
export const DISABLED_BUTTON = 'DISABLED_BUTTON';
export const CLEAN = 'CLEAN';
export const REMOVE_PROFILE_SPAC = 'REMOVE_PROFILE_SPAC';
